import React from 'react';
import PropType from 'prop-types';
import { FormGroup, InputGroup, FormControl } from 'react-bootstrap';

const Filters = ({ onChangeFilterByName }) => (
  <React.Fragment>
    <FormGroup className="tvt-report-list__filter-by-name">
      <InputGroup>
        <InputGroup.Addon>
          <i className="fa fa-search" />
        </InputGroup.Addon>
        <FormControl
          type="text"
          placeholder="Search by report name"
          onChange={onChangeFilterByName}
        />
      </InputGroup>
    </FormGroup>
  </React.Fragment>
);

Filters.propTypes = {
  onChangeFilterByName: PropType.func.isRequired
};

export default Filters;
